import { Challenge } from '../models';
import { ChallengeRepository } from '../repositories';
import { logger } from '@/src/core/utils';

export class AcceptChallengeUseCase {
  constructor(private challengeRepository: ChallengeRepository) {}

  async execute(challengeId: string, tournamentId: string): Promise<Challenge> {
    logger.debug('AcceptChallenge', 'Accepting challenge', { challengeId, tournamentId });

    const challenge = await this.challengeRepository.acceptChallenge(challengeId, tournamentId);

    logger.debug('AcceptChallenge', 'Successfully accepted challenge');

    return challenge;
  }
}
